// src/menu-items/user-management.ts
import { Group, User } from 'iconoir-react';

const userManagement = {
  id: 'user-management-group',
  title: 'User Management',
  type: 'group',
  children: [
    {
      id: 'users-list',
      title: 'Users',
      type: 'item',
      url: '/user-management/list',
      icon: Group,
      breadcrumbs: true
    },
    {
      id: 'user-create',
      title: 'Create User',
      type: 'item',
      url: '/user-management/create',
      icon: User,
      breadcrumbs: true
    }
  ]
};

export default userManagement;
